import { render, staticRenderFns } from "./SelfUpdateAction.vue?vue&type=template&id=5c0f0014&scoped=true"
import script from "./SelfUpdateAction.vue?vue&type=script&lang=js"
export * from "./SelfUpdateAction.vue?vue&type=script&lang=js"
import style0 from "./SelfUpdateAction.vue?vue&type=style&index=0&id=5c0f0014&prod&scoped=true&lang=css"
import style1 from "./SelfUpdateAction.vue?vue&type=style&index=1&id=5c0f0014&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f0014",
  null
  
)

export default component.exports